// The longest path through a constellation (its diameter), for placing the
// label pill on the midpoint of the middle line.
import type { Line } from '@wits/core';

export function longestPath(nodes: readonly number[], lines: readonly Line[]): number[] {
  if (nodes.length === 0) return [];
  const adj = new Map<number, number[]>();
  for (const id of nodes) adj.set(id, []);
  for (const [a, b] of lines) {
    adj.get(a)?.push(b);
    adj.get(b)?.push(a);
  }
  const farthest = (start: number): { end: number; parent: Map<number, number | null> } => {
    const parent = new Map<number, number | null>([[start, null]]);
    const depth = new Map<number, number>([[start, 0]]);
    const queue = [start];
    let end = start;
    while (queue.length) {
      const u = queue.shift()!;
      if (depth.get(u)! > depth.get(end)!) end = u;
      for (const v of adj.get(u) ?? []) {
        if (!parent.has(v)) {
          parent.set(v, u);
          depth.set(v, depth.get(u)! + 1);
          queue.push(v);
        }
      }
    }
    return { end, parent };
  };
  const { end: a } = farthest(nodes[0]!);
  const { end: b, parent } = farthest(a);
  const path: number[] = [];
  for (let cur: number | null = b; cur !== null; cur = parent.get(cur) ?? null) path.push(cur);
  return path;
}
